// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Reg3i","actions":"GroupTable_actions__2DSIA","deleteModalFooter":"GroupTable_deleteModalFooter__2O36-"};